export default __webpack_public_path__ + "static/media/24h-recall-icon.b2b97abf.svg";